import React from 'react';
import { useNavigate } from 'react-router-dom';

const withNavigate = WrappedComponent => {
    // eslint-disable-next-line react/display-name
    return props => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

export default withNavigate;
